"use client";

import { useEffect, useRef, useState } from "react";

import { CcCustomCalBooking } from "@/components/booking/CcCustomCalBooking";
import type { BookCallFormCopyOverrides } from "@/lib/book-call-popup-copy";
import type { Lang } from "@/lib/types";

type CcAxBookingProps = {
  lang: Lang;
  formCopy?: BookCallFormCopyOverrides;
};

/**
 * The booking calendar embedded on the ad X-ray page. Like AI-kollen's, it
 * mounts (and fetches a month of slots) only when the section comes near.
 */
export function CcAxBooking({ lang, formCopy }: CcAxBookingProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [near, setNear] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || near) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setNear(true);
      },
      { rootMargin: "800px 0px" },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [near]);

  return (
    <div ref={ref} className="cc-ak-booking__widget">
      {near ? (
        <CcCustomCalBooking
          lang={lang}
          bookingVariant="ad-xray"
          formCopyOverrides={formCopy}
        />
      ) : null}
    </div>
  );
}
